import { useState, useCallback, useEffect } from 'react';

const labImages = [
  {
    src: "https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/43457cc6-a84b-4ec8-9f7e-4f6e4b7b1c30_compressed_WhatsApp-Image-2026-07-28-at-12.24.10-PM.webp",
    alt: "Laboratorio de Poly Alphas Chemicals C.A. con múltiples botellas de prueba de demulsificante alineadas en mesa de trabajo",
    caption: "Laboratorio de Pruebas – Setup Completo",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/b4061420-9d1e-4426-9992-4d94601e0fd8_compressed_WhatsApp-Image-2026-07-28-at-12.24.09-PM-2.webp",
    alt: "Pruebas de dosis de demulsificante con jeringas insertadas en botellas pequeñas para evaluación de separación",
    caption: "Evaluación de Dosis Óptima",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/6e06cd38-da51-4465-8d4c-ba0f91e5be76_compressed_WhatsApp-Image-2026-07-28-at-12.24.09-PM.webp",
    alt: "Botellas numeradas con muestras de crudo en laboratorio de Poly Alphas Chemicals C.A. listas para análisis",
    caption: "Muestras de Crudo – Pruebas de Separación",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/d22ca550-b932-4951-8780-361cd2d7fec3_compressed_WhatsApp-Image-2026-07-28-at-12.24.08-PM-1.webp",
    alt: "Secuencia de botellas con crudo numeradas del 5 al 9 mostrando etapas de prueba de demulsificación",
    caption: "Resultados Secuenciales de Separación",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/5b41f56eb29c2520b2a33d683b226285.jpeg",
    alt: "Doce botellas numeradas del 1 al 12 con muestras de crudo dispuestas en fila sobre banco de laboratorio de Poly Alphas Chemicals C.A.",
    caption: "Doce Muestras Secuenciales – Banco de Laboratorio",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/df4b7bb5a027de94697dc7ee67a8182d.jpeg",
    alt: "Tres botellas de vidrio con muestras de crudo mostrando separación de fases agua-aceite con interfase claramente visible",
    caption: "Separación de Fases – Interfase Clara",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/4391104b0a5ec37ea08d931cfb801c88.jpeg",
    alt: "Probetas graduadas con muestras de crudo mostrando la separación de fases agua-aceite en proceso de evaluación de demulsificante",
    caption: "Separación de Fases en Probetas Graduadas",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/6726c796ffa8727d0409bccb6548e377.jpeg",
    alt: "Probetas graduadas con muestras de crudo en rack de laboratorio mostrando separación de fases a diferentes niveles",
    caption: "Evaluación de Separación en Rack de Laboratorio",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/cb6cf83152b2e9f5faae4dff399c104e.jpeg",
    alt: "Dos probetas graduadas grandes con separación de fases agua-aceite y emulsión en la interfase visible",
    caption: "Separación de Fases en Probetas de Gran Volumen",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/42862eddf739d32b013cdf187dde0b32.jpeg",
    alt: "Técnico dosificando muestra con pipeta sobre balanza analítica digital en laboratorio de formulación de demulsificantes",
    caption: "Dosificación Precisa en Balanza Analítica",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/82c727ebc95c127b734df257ae7b9094.jpeg",
    alt: "Botellas de vidrio numeradas del 5 al 8 con muestras de crudo oscuro dispuestas en bandeja metálica de laboratorio",
    caption: "Muestras Secuenciales para Análisis",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/2540fc7569f5d42988e11c198c37ba8a.jpeg",
    alt: "Viales pequeños con jeringas de precisión y etiquetas amarillas preparados para evaluación de dosis de demulsificante",
    caption: "Evaluación de Dosis con Jeringas de Precisión",
  },
];

const carouselImages = [
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/5b41f56eb29c2520b2a33d683b226285.jpeg",
    alt: "Doce botellas numeradas del 1 al 12 con muestras de crudo dispuestas en fila sobre banco de laboratorio de Poly Alphas Chemicals C.A.",
    caption: "Doce Muestras Secuenciales – Banco de Laboratorio",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/df4b7bb5a027de94697dc7ee67a8182d.jpeg",
    alt: "Tres botellas de vidrio con muestras de crudo mostrando separación de fases agua-aceite con interfase claramente visible",
    caption: "Separación de Fases – Interfase Clara",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/6726c796ffa8727d0409bccb6548e377.jpeg",
    alt: "Probetas graduadas con muestras de crudo en rack de laboratorio mostrando separación de fases a diferentes niveles",
    caption: "Evaluación de Separación en Rack de Laboratorio",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/cb6cf83152b2e9f5faae4dff399c104e.jpeg",
    alt: "Dos probetas graduadas grandes con separación de fases agua-aceite y emulsión en la interfase visible",
    caption: "Separación de Fases en Probetas de Gran Volumen",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/42862eddf739d32b013cdf187dde0b32.jpeg",
    alt: "Técnico dosificando muestra con pipeta sobre balanza analítica digital en laboratorio de formulación de demulsificantes",
    caption: "Dosificación Precisa en Balanza Analítica",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/4391104b0a5ec37ea08d931cfb801c88.jpeg",
    alt: "Probetas graduadas con muestras de crudo mostrando la separación de fases agua-aceite en proceso de evaluación de demulsificante",
    caption: "Separación de Fases en Probetas Graduadas",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/82c727ebc95c127b734df257ae7b9094.jpeg",
    alt: "Botellas de vidrio numeradas del 5 al 8 con muestras de crudo oscuro dispuestas en bandeja metálica de laboratorio",
    caption: "Muestras Secuenciales para Análisis",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/2540fc7569f5d42988e11c198c37ba8a.jpeg",
    alt: "Viales pequeños con jeringas de precisión y etiquetas amarillas preparados para evaluación de dosis de demulsificante",
    caption: "Evaluación de Dosis con Jeringas de Precisión",
  },
];

export default function AllianceSection() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const openLightbox = useCallback((index: number) => setLightboxIndex(index), []);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const prevImage = useCallback(() => {
    if (lightboxIndex !== null) {
      setLightboxIndex(lightboxIndex === 0 ? labImages.length - 1 : lightboxIndex - 1);
    }
  }, [lightboxIndex]);
  const nextImage = useCallback(() => {
    if (lightboxIndex !== null) {
      setLightboxIndex(lightboxIndex === labImages.length - 1 ? 0 : lightboxIndex + 1);
    }
  }, [lightboxIndex]);

  // Auto-advance carousel every 3 seconds
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [isPaused]);

  return (
    <section id="alianza" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Alliance Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-14 md:mb-20">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
                <i className="ri-shake-hands-line text-sm w-4 h-4 flex items-center justify-center" />
                Nuestra Alianza Estratégica
              </div>

              <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 leading-tight mb-6">
                Fabricante <span className="text-primary-500">Rixin Corp</span>{' '}
                + Asesoría <span className="text-accent-500">Poly Alphas</span>
              </h2>

              <p className="text-foreground-600 text-sm md:text-base leading-relaxed text-justify">
                <strong>RESINVENCA RESINAS DE VENEZUELA C.A.</strong> opera como importador y distribuidor de demulsificantes de alta calidad,
                formulados por <strong>Rixin Corp en China</strong> y entregados <strong>puesto en Venezuela</strong>. Desde el año <strong>2022</strong>,
                trabajamos junto a <strong>Poly Alphas Chemicals C.A.</strong> como nuestro asesor técnico de confianza en el país,
                asegurando que cada producto importado cumpla con los estándares de separación agua-crudo requeridos por cada campo petrolero.
              </p>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mt-4 text-justify">
                Gracias a esta alianza, <strong>Poly Alphas Chemicals C.A.</strong> evalúa y valida la eficacia de los demulsificantes
                importados mediante pruebas físico-químicas in situ, determinando la dosis óptima y el comportamiento de separación
                según las condiciones reales del crudo venezolano. Este respaldo técnico nos permite ofrecer a nuestros
                clientes productos probados, con resultados medibles y tiempos de separación optimizados.
              </p>

              <div className="flex flex-wrap gap-3 mt-6">
                {[
                  { icon: 'ri-building-4-line', text: 'Rixin Corp – Fabricante China' },
                  { icon: 'ri-ship-line', text: 'Importación Directa' },
                  { icon: 'ri-microscope-line', text: 'Asesoría Técnica Local' },
                  { icon: 'ri-test-tube-line', text: 'Validación Físico-Química' },
                ].map((item) => (
                  <div
                    key={item.text}
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-accent-100/60 text-accent-700 text-xs font-medium border border-accent-200/40"
                  >
                    <i className={`${item.icon} w-3 h-3 flex items-center justify-center`} />
                    {item.text}
                  </div>
                ))}
              </div>
            </div>

            {/* Carousel - Auto-rotating images */}
            <div
              className="relative rounded-lg overflow-hidden border border-background-200/60 w-full h-[280px] sm:h-[320px] md:h-[380px] bg-background-200"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              {carouselImages.map((image, index) => (
                <div
                  key={image.src}
                  className="absolute inset-0 transition-opacity duration-700 ease-in-out"
                  style={{
                    opacity: index === currentSlide ? 1 : 0,
                    visibility: index === currentSlide ? 'visible' : 'hidden',
                    zIndex: index === currentSlide ? 10 : 0,
                  }}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover"
                    loading="eager"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <p className="text-white font-heading text-sm md:text-base font-semibold">
                      {image.caption}
                    </p>
                  </div>
                </div>
              ))}

              {/* Dot indicators */}
              <div className="absolute bottom-4 right-4 flex items-center gap-1.5 z-20">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                      index === currentSlide
                        ? 'bg-white w-5'
                        : 'bg-white/50 w-2 hover:bg-white/80'
                    }`}
                    aria-label={`Ver imagen ${index + 1}`}
                  />
                ))}
              </div>

              {/* Progress bar */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-white/20 z-20">
                <div
                  className="h-full bg-accent-500 transition-all duration-300 ease-linear"
                  style={{
                    width: isPaused ? '0%' : `${((currentSlide + 1) / carouselImages.length) * 100}%`,
                  }}
                />
              </div>
            </div>
          </div>

          {/* Gallery of Lab Results */}
          <div className="border-t border-background-200/60 pt-14 md:pt-20">
            <div className="text-center mb-8 md:mb-10">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                <i className="ri-flask-line text-sm w-4 h-4 flex items-center justify-center" />
                Resultados de la Alianza
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
                Pruebas de Laboratorio <span className="text-primary-500">en Acción</span>
              </h3>
              <p className="text-foreground-500 text-sm max-w-lg mx-auto">
                Imágenes reales de las pruebas de separación agua-crudo realizadas por Poly Alphas Chemicals C.A. para validar nuestros demulsificantes importados de Rixin Corp.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {labImages.map((image, index) => (
                <div
                  key={image.src}
                  onClick={() => openLightbox(index)}
                  className="group relative rounded-lg overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-300/60 transition-all duration-300"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                    <p className="text-white font-heading text-sm font-semibold">{image.caption}</p>
                  </div>
                  <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-zoom-in-line text-sm" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-[100] bg-foreground-950/95 backdrop-blur-sm flex items-center justify-center"
          onClick={closeLightbox}
        >
          <button
            onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
            className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-close-line text-xl" />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-4 md:left-8 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg md:text-xl" />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-4 md:right-8 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-lg md:text-xl" />
          </button>

          <div className="max-w-5xl w-full mx-4 md:mx-8" onClick={(e) => e.stopPropagation()}>
            <div className="rounded-lg overflow-hidden">
              <img
                src={labImages[lightboxIndex].src}
                alt={labImages[lightboxIndex].alt}
                className="w-full max-h-[70vh] object-contain"
              />
            </div>
            <div className="text-center mt-4">
              <p className="text-white font-heading text-base font-semibold">{labImages[lightboxIndex].caption}</p>
              <p className="text-foreground-400 text-xs mt-1">{labImages[lightboxIndex].alt}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}